import { useTranslation } from "../i18n";
import InventoryAdmin from "../components/InventoryAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminInventory = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="inventory_title"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "inventory_title" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("inventory_hint")}</p>
                <InventoryAdmin />
            </div>
        </div>
    );
};

export default AdminInventory;
